<div class='Login container'>
  <div class='Login_wrapper d-flex flex-column'>
    <div class='Login_wrapper_header'>
      <h1 class=''>Login</h1>
      <h5 class='mt-3'>
        Ready to set more meetings today? The President’s Club is calling.
      </h5>
      <div class='AuthenticatedLayout-container-alerts container pt-3'>
        <div
          *ngIf='showAlert && alertMessage'
          class='alert alert-danger alert-dismissible fade show'
          role='alert'>
          {{ alertMessage }}
          <button
            (click)='closeAlert()'
            aria-label='Close'
            class='btn-close'
            data-bs-dismiss='alert'
            type='button'></button>
        </div>
      </div>
    </div>
    <div class='Login_wrapper_body p-5'>
      <form
        (keydown)='onKeyDown($event)'
        [formGroup]='loginForm'
        accept-charset='UTF-8'
        action='/accounts/sign_in'
        class='form-sign-in sign_in_form pt-3'
        id='new_account'
        method='post'>
        <div style='margin: 0; padding: 0; display: inline'>
          <input name='utf8' type='hidden' value='✓' /><input
          name='authenticity_token'
          type='hidden'
          value='ODdWk9O1QDGOG0Bq3T/nY0mgyZ9xuslZYMzWfc4dIGc=' />
        </div>
        <div class='row align-items-center mb-3'>
          <div class='col col-12 col-sm-2 mb-3 mb-sm-0'>
            <label class='Login_fieldLabel' for='login-email'>Email</label>
          </div>
          <div class='col col-12 col-sm-10'>
            <app-text-field
              autocomplete='username'
              formControlName='username'
              inputId='login-email'
              name='username'
              placeholder='Email address'
              type='email'></app-text-field>
          </div>
        </div>
        <div
          *ngIf='username.invalid && (username.dirty || username.touched)'
          class='alert alert-danger'>
          <div *ngIf='username.errors.required'>Email address is required.</div>
          <div *ngIf='username.errors.minlength'>
            Email address must be at least 4 characters long.
          </div>
          <div *ngIf='username.errors.email'>
            Please, enter valid email address
          </div>
        </div>
        <div class='row align-items-center mb-5'>
          <div class='col col-12 col-sm-2 mb-3 mb-sm-0'>
            <label class='Login_fieldLabel' for='login-password'>Password</label>
          </div>
          <div class='col col-12 col-sm-10'>
            <app-text-field
              [allowViewPassword]='true'
              autocomplete='current-password'
              formControlName='password'
              inputId='login-password'
              name='password'
              placeholder='Password'
              type='password'></app-text-field>
          </div>
        </div>
        <div
          *ngIf='password.invalid && (password.dirty || password.touched)'
          class='alert alert-danger'>
          <div *ngIf='password.errors.required'>Password is required.</div>
          <div *ngIf='password.errors.minlength'>
            Password must be at least 6 characters long.
          </div>
        </div>
        <div>
          <app-button
            [Click]='onSubmit'
            [disabled]="loginInProgress"
            [color]="'orange'"
            [size]="'big'"
            [text]="'Login'"
            class='Login_wrapper_body_button'></app-button>
        </div>
        <div class='mt-3 Login_wrapper_body_sso' *ngIf='showSsoSection'>
          <div class='d-flex align-items-center mb-3'>
            <hr class='flex-grow-1'><span class='mx-3 text-muted'>or</span><hr class='flex-grow-1'>
          </div>
          <div
            *ngIf="showGoogleButton && googleMode === 'button'"
            #googleBtn
            class='Login_wrapper_body_sso_googleRendered mb-3'></div>
          <button
            *ngIf="showGoogleButton && googleMode === 'redirect'"
            (click)='loginWithGoogle()'
            class='Login_wrapper_body_sso_google mb-3'
            type='button'>
            <svg
              aria-hidden='true'
              class='Login_wrapper_body_sso_google_logo'
              viewBox='0 0 48 48'
              xmlns='http://www.w3.org/2000/svg'>
              <path fill='#EA4335' d='M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z'/>
              <path fill='#4285F4' d='M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z'/>
              <path fill='#FBBC05' d='M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z'/>
              <path fill='#34A853' d='M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z'/>
            </svg>
            <span>Sign in with Google</span>
          </button>
          <button
            *ngIf='showSpacescoutButton'
            (click)='loginWithSpacescout()'
            class='Login_wrapper_body_sso_spacescout mb-3'
            type='button'>
            <span class='Login_wrapper_body_sso_spacescout_label'>Sign in with</span>
            <img
              alt='SpaceScout'
              class='Login_wrapper_body_sso_spacescout_logo'
              src='assets/images/sso/spacescout-logo-horizontal.png' />
          </button>
        </div>
        <div
          class='Login_wrapper_body_footer mt-3 d-flex justify-content-center flex-column'>
          <p>
            Forgot password? Click
            <a [routerLink]="['/forgot_password']" class='forg'>here</a>
          </p>
          <p class='mt-2'>
            Don't have an account. <a [routerLink]="['/register']">Sign up.</a>
          </p>
        </div>
      </form>
    </div>
  </div>
</div>
